<template>
  <div class="featured" :class="{ 'is-active': active }" v-on:click="clicked()">
    <div class="featured__thumb">
      <img :src="thumb" :alt="channel_data.name" @error="fallbackThumb" />
    </div>
    <div class="featured__body">
      <div class="featured__name">{{ channel_data.name }}</div>
      <div class="featured__meta">{{ channel_data.meta || channel_data.description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stream-slide',
  props: {
    channel_data: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      thumb: this.channel_data.banner
    }
  },
  methods: {
    // banners occasionally 404 on Twitch's CDN — fall back to the avatar
    fallbackThumb () {
      if (this.thumb !== this.channel_data.prof_pic) {
        this.thumb = this.channel_data.prof_pic
      }
    },
    clicked () {
      this.$emit('select', this.channel_data)
    }
  }
}
</script>

<style scoped>
.featured {
  display: flex;
  gap: 12px;
  background: linear-gradient(180deg, var(--sl-surface), var(--sl-bg-elev));
  border: 1px solid var(--sl-line);
  border-radius: var(--sl-radius);
  padding: 10px;
  cursor: pointer;
  transition: border-color 0.15s;
  text-align: left;
}

.featured:hover {
  border-color: rgba(224, 31, 40, 0.5);
}

.featured.is-active {
  border-color: var(--sl-red);
  background: linear-gradient(180deg, rgba(224, 31, 40, 0.16), var(--sl-bg-elev));
}

.featured__thumb {
  width: 96px;
  height: 60px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  background: repeating-linear-gradient(45deg, #1a1a20 0 8px, #202028 8px 16px);
}

.featured__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.featured__body {
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.featured__name {
  font-weight: 700;
  font-size: 15px;
  line-height: 1.15;
}

.featured__meta {
  font-size: 12.5px;
  color: #85858f;
  margin-top: 3px;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/stream-slide.vue